/** 买家 Mock数据 */

import type { Buyer } from '../types';
import { randomFloat } from '../utils/mockHelper';

const buyers: Buyer[] = [
  {
    id: 'BUY001', name: 'John Smith', company: 'FreshFoods Inc.',
    country: '美国', creditRating: 'A', creditLimit: 500000,
    activeOrders: 12, totalSpent: 2340000, joinedAt: '2023-03-15T00:00:00Z',
    bluGuardLevel: 'PLATINUM',
  },
  {
    id: 'BUY002', name: 'Maria Rossi', company: 'EuroGrocers Ltd.',
    country: '意大利', creditRating: 'A', creditLimit: 300000,
    activeOrders: 8, totalSpent: 1560000, joinedAt: '2023-05-20T00:00:00Z',
    bluGuardLevel: 'GOLD',
  },
  {
    id: 'BUY003', name: 'Takeshi Yamamoto', company: 'TokyoFresh Co.',
    country: '日本', creditRating: 'A', creditLimit: 400000,
    activeOrders: 15, totalSpent: 3200000, joinedAt: '2023-01-10T00:00:00Z',
    bluGuardLevel: 'PLATINUM',
  },
  {
    id: 'BUY004', name: 'Ahmed Hassan', company: 'GlobalSpice LLC',
    country: '阿联酋', creditRating: 'A', creditLimit: 200000,
    activeOrders: 5, totalSpent: 890000, joinedAt: '2023-08-05T00:00:00Z',
    bluGuardLevel: 'SILVER',
  },
  {
    id: 'BUY005', name: 'Sarah Miller', company: 'MiddleEast Foods',
    country: '沙特阿拉伯', creditRating: 'A', creditLimit: 350000,
    activeOrders: 10, totalSpent: 1890000, joinedAt: '2023-04-18T00:00:00Z',
    bluGuardLevel: 'GOLD',
  },
  {
    id: 'BUY006', name: 'David Kim', company: 'Pacific Rim Imports',
    country: '韩国', creditRating: 'A', creditLimit: 250000,
    activeOrders: 7, totalSpent: 1200000, joinedAt: '2023-06-22T00:00:00Z',
    bluGuardLevel: 'SILVER',
  },
  {
    id: 'BUY007', name: 'Anna Larsson', company: 'Nordic Food Group',
    country: '瑞典', creditRating: 'A', creditLimit: 450000,
    activeOrders: 9, totalSpent: 2100000, joinedAt: '2023-02-14T00:00:00Z',
    bluGuardLevel: 'PLATINUM',
  },
  {
    id: 'BUY008', name: 'Michael Chen', company: 'African Trade Hub',
    country: '尼日利亚', creditRating: 'C', creditLimit: 150000,
    activeOrders: 4, totalSpent: 560000, joinedAt: '2024-01-08T00:00:00Z',
    bluGuardLevel: 'BASIC',
  },
  {
    id: 'BUY009', name: 'Carlos Ruiz', company: 'LatinFresh S.A.',
    country: '巴西', creditRating: 'A', creditLimit: 280000,
    activeOrders: 6, totalSpent: 980000, joinedAt: '2023-09-30T00:00:00Z',
    bluGuardLevel: 'SILVER',
  },
  {
    id: 'BUY010', name: 'Priya Patel', company: 'Southeast Asia Foods',
    country: '印度', creditRating: 'A', creditLimit: 320000,
    activeOrders: 11, totalSpent: 1780000, joinedAt: '2023-07-12T00:00:00Z',
    bluGuardLevel: 'GOLD',
  },
  {
    id: 'BUY011', name: 'James Wilson', company: 'Australian Wholesale',
    country: '澳大利亚', creditRating: 'A', creditLimit: 380000,
    activeOrders: 8, totalSpent: 1450000, joinedAt: '2023-11-05T00:00:00Z',
    bluGuardLevel: 'GOLD',
  },
  {
    id: 'BUY012', name: 'Sophie Martin', company: 'Canadian Grocers Co.',
    country: '加拿大', creditRating: 'A', creditLimit: 220000,
    activeOrders: 3, totalSpent: 670000, joinedAt: '2024-03-20T00:00:00Z',
    bluGuardLevel: 'BASIC',
  },
];

export const mockBuyers: Buyer[] = buyers;
